
import { Component, Mixins } from 'vue-property-decorator';

import { View } from 'client-website-ts-library/plugins';

import SideBySide from '../components/Layout/SideBySide.vue';

@Component({
  components: {
    SideBySide,
  },
})
export default class Services extends Mixins(View) {
}
